export const colorList = [
    {
        name: '红色',
        label: <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ width: 18, height: 18, borderRadius: '50%', background: 'red', display: 'inline-block', border: '2px solid rgba(255,255,255,0.2)' }} />
            <span>红色</span>
        </div>,
        value: 'red',
    },
    {
        name: '绿色',
        label: <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ width: 18, height: 18, borderRadius: '50%', background: 'green', display: 'inline-block', border: '2px solid rgba(255,255,255,0.2)' }} />
            <span>绿色</span>
        </div>,
        value: 'green',
    },
    {
        name: '紫白',
        label: <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ width: 18, height: 18, borderRadius: '50%', background: '#CCCCFF', display: 'inline-block', border: '2px solid rgba(255,255,255,0.2)' }} />
            <span>紫白色</span>
        </div>,
        value: '#CCCCFF',
    },
];

// 正式赛、活动赛的外战对手使用更完整的基础队服色板。
export const opponentColorList = [
    { name: '红色', value: 'red' },
    { name: '橙色', value: '#F97316' },
    { name: '黄色', value: '#EAB308' },
    { name: '荧光绿', value: '#84CC16' },
    { name: '绿色', value: 'green' },
    { name: '青色', value: '#06B6D4' },
    { name: '天蓝', value: '#0EA5E9' },
    { name: '蓝色', value: '#3B82F6' },
    { name: '靛蓝', value: '#6366F1' },
    { name: '紫色', value: '#8B5CF6' },
    { name: '粉色', value: '#EC4899' },
    { name: '紫白', value: '#CCCCFF' },
    { name: '白色', value: '#F8FAFC' },
    { name: '黑色', value: '#1F2937' },
];
